import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../../../utils/validators/string';
export const ticketRedemptionCodeFormatValidator = Validator.object({
    partialFormat: nonEmptyStringValidator,
    fullFormat: nonEmptyStringValidator,
    prefixLength: Validator.number({ min: 0 })
});
